module.exports = __webpack_public_path__ + "img/mumakong.6b7531bd.png";